import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const theme = {
    primary: '#9190B5',
    secondary: '#b6c093',
    accent: '#ccde44',
    error: '#FF5252',
    info: '#2196F3',
    success: '#ccde44',
    warning: '#FFC107',
}

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
    theme: {
        themes: {
            dark: theme,
            light: theme,
        },
    },
});
